module.exports = __webpack_public_path__ + "static/img/door-gf4.5ebe818.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/door-gf/door-gf4.jpg
// module id = dERQ
// module chunks = 0